import(/* webpackMode: "eager", webpackExports: ["LegalDocumentPage"] */ "/app/src/components/legal/LegalDocumentPage.tsx");
